import { ChangeLogEntityType, useGetChangeLogByEntity } from '../../../../../api/created/changeLog.ts';
import { useUsers } from '../../../../../api/created/users.ts';
import type { IBezugspersonWithPerson } from '../../../../../api/generated/bezugperson-controller/bezugperson-controller';
import { ChangeHistoryModal } from '../../../../../components/history/ChangeHistoryModal.tsx';
import { mapChangeLogEntriesToReferencePersonHistory } from './referencePersonHistory.ts';

type ReferencePersonHistoryModalProps = {
  open: boolean;
  onClose: () => void;
  item: IBezugspersonWithPerson | null;
};

function getReferencePersonName(item: IBezugspersonWithPerson | null) {
  const name = [item?.firstName, item?.lastName].filter(Boolean).join(' ').trim();
  return name || 'Bezugsperson';
}

export function ReferencePersonHistoryModal({ open, onClose, item }: ReferencePersonHistoryModalProps) {
  const referencePersonId = item?.id;
  const { data: changeLogEntries = [], isLoading } = useGetChangeLogByEntity(
    ChangeLogEntityType.PERSON_RELATION,
    referencePersonId,
    {
      enabled: open && !!referencePersonId,
    },
  );
  const { data: users = [] } = useUsers({ enabled: open && !!referencePersonId });
  const historyEntries = mapChangeLogEntriesToReferencePersonHistory(changeLogEntries, { users });
  const referencePersonName = getReferencePersonName(item);

  return (
    <ChangeHistoryModal
      open={open}
      onClose={onClose}
      title={`Verlauf – ${referencePersonName}`}
      subject="Die Bezugsperson"
      entityName={referencePersonName}
      entries={historyEntries.map((entry) => ({
        ...entry,
        changedBy: entry.changedByName,
      }))}
      isLoading={isLoading}
    />
  );
}
